var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('layout-report-step', {
    attrs: {
      "isDone": _vm.isDone,
      "title": _vm.header.title,
      "description": _vm.header.description,
      "image": _vm.header.image,
      "debug": _vm.header.debug
    }
  }, [_c('v-card', {
    staticClass: "pt-4 pr-4 pl-4",
    attrs: {
      "flat": "",
      "max-width": "800"
    }
  }, [_c('v-form', {
    model: {
      value: _vm.valid,
      callback: function callback($$v) {
        _vm.valid = $$v;
      },
      expression: "valid"
    }
  }, [_c('div', {
    staticClass: "caption mb-4"
  }, [_vm._v(_vm._s(_vm.$t("report.currentLocation.locationTitle")))]), _c('v-radio-group', {
    on: {
      "change": _vm.getPositionIfTrue
    },
    model: {
      value: _vm.isAtVehicleLocation,
      callback: function callback($$v) {
        _vm.isAtVehicleLocation = $$v;
      },
      expression: "isAtVehicleLocation"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": _vm.$t('report.currentLocation.isAtLocation'),
      "value": true
    }
  }), _c('v-radio', {
    attrs: {
      "label": _vm.$t('report.currentLocation.isNotAtLocation'),
      "value": false
    }
  })], 1), _vm.isAtVehicleLocation !== undefined ? _c('div', [_vm.isLoadingGeo ? _c('div', {
    staticClass: "caption"
  }, [_c('v-progress-circular', {
    attrs: {
      "size": 20,
      "indeterminate": "",
      "color": _vm.color
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t("report.currentLocation.geoLoading")))])], 1) : _vm.address.geo.lat && _vm.address.geo.lng && _vm.isAtVehicleLocation ? _c('div', {
    staticClass: "caption mb-6"
  }, [_c('v-icon', {
    attrs: {
      "color": "success"
    }
  }, [_vm._v("mdi-map-marker")]), _c('span', [_vm._v(_vm._s(_vm.$t("report.currentLocation.geoSuccess")) + " (" + _vm._s(_vm.address.geo.lat.toLocaleString("de-DE", {
    minimumFractionDigits: 6,
    maximumFractionDigits: 6
  })) + ", " + _vm._s(_vm.address.geo.lng.toLocaleString("de-DE", {
    minimumFractionDigits: 6,
    maximumFractionDigits: 6
  })) + ")")])], 1) : _vm.isGeoPermissionDenied && _vm.isAtVehicleLocation ? _c('div', {
    staticClass: "caption mb-6"
  }, [_c('v-icon', {
    attrs: {
      "color": "warning"
    }
  }, [_vm._v("mdi-alert-circle")]), _c('span', [_vm._v(_vm._s(_vm.$t("report.currentLocation.geoPermissionDenied")))]), _c('v-btn', {
    staticClass: "mt-2",
    attrs: {
      "elevation": "0",
      "color": "primary"
    },
    on: {
      "click": _vm.retryGeolocation
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("report.currentLocation.retryGeolocation")) + " ")])], 1) : _vm._e(), _c('div', {
    staticClass: "caption mb-4"
  }, [_vm._v(_vm._s(_vm.$t("report.currentLocation.addressTitle")))]), _c('v-text-field', {
    attrs: {
      "rules": _vm.requiredRule,
      "outlined": "",
      "label": _vm.$t('report.currentLocation.street')
    },
    model: {
      value: _vm.address.street,
      callback: function callback($$v) {
        _vm.$set(_vm.address, "street", $$v);
      },
      expression: "address.street"
    }
  }), _c('v-text-field', {
    attrs: {
      "rules": _vm.rules(_vm.RulesEnum.REQUIRED_RULE, _vm.RulesEnum.ZIP_GERMANY_RULE),
      "outlined": "",
      "label": _vm.$t('report.currentLocation.zip')
    },
    model: {
      value: _vm.address.zip,
      callback: function callback($$v) {
        _vm.$set(_vm.address, "zip", $$v);
      },
      expression: "address.zip"
    }
  }), _c('v-text-field', {
    attrs: {
      "rules": _vm.requiredRule,
      "outlined": "",
      "label": _vm.$t('report.currentLocation.city')
    },
    model: {
      value: _vm.address.city,
      callback: function callback($$v) {
        _vm.$set(_vm.address, "city", $$v);
      },
      expression: "address.city"
    }
  })], 1) : _vm._e()], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }